<template>
    <div>
        <Header color="black" type="page" style="margin-left:30px" />
        <div class="non-employee-container">
            <div>
                <div>
                    <img src="../assets/pictogram_sad-face_96.svg" alt="sad face" style="">
                </div>
                <div class="trans20">
                    <h1 style="">Sorry.</h1>
                    <p>These offers are available to employees only.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header'
export default {
    name: "NonEmployee",
    components: {
        Header
    }
}
</script>

<style scoped>
.non-employee-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: calc(100vh - 150px);
}

.non-employee-container>div {
    border-radius: 13px;
    background-color: #F3F4F6;
    padding: 40px 60px;
    vertical-align: middle;
    display: flex;
    margin: 10px;
}

.non-employee-container div img {
    width: 96px;
    height: 96px;
    margin-right: 8px;
}

.non-employee-container h1 {
    font-size: 24px;
    font-weight: 600;
    color: #000000;
    margin: 0;
}

.trans20 {
    transform: translateY(20px);
}

@media screen and (max-width: 380px) {
    .non-employee-container div {
        display: block;
    }

    .trans20 {
        transform: none;
    }
}
</style>